<div class="resume-dialog">
  <header class="resume-dialog__header">
    <div class="title-block">
      <h2>
        {{ resume.title || 'Untitled resume' }}
      </h2>
      <div class="meta-row">
        <span class="category">
          {{ resume.primaryCategory || 'Uncategorized' }}
        </span>
        <span class="file-type">
          {{ resume.fileType | uppercase }}
        </span>
        <span class="date">
          Created: {{ resume.createdAt | date: 'short' }}
        </span>
      </div>

      <div class="label-row" *ngIf="resume.labels?.length">
        <span class="label-chip" *ngFor="let lbl of resume.labels">
          {{ lbl }}
        </span>
      </div>
    </div>

    <button
      type="button"
      class="icon-button close-btn"
      (click)="close()"
      aria-label="Close"
    >
      <i class="fa-solid fa-xmark"></i>
    </button>
  </header>

  <section class="resume-dialog__body">
    <div class="column">
      <div class="block" *ngIf="resume.description">
        <h3>Summary / notes</h3>
        <p>
          {{ resume.description }}
        </p>
      </div>

      <div class="block" *ngIf="resume.fileUrl">
        <h3>Source file</h3>
        <p class="hint">
          This card is based on the attached resume file. You can open it in a new tab.
        </p>
        <button type="button" class="text-button" (click)="openFile()">
          <i class="fa fa-file"></i>
          <span>Open resume file</span>
        </button>
      </div>
    </div>

    <div class="column">
      <div class="block">
        <h3>Enhanced resume</h3>

        <div *ngIf="resume.status === 'enhancing'" class="status-banner">
          <i class="fa fa-spinner fa-spin"></i>
          <span>Enhancing resume for the last job request…</span>
        </div>

        <pre *ngIf="resume.enhancedText" class="enhanced-body">
{{ resume.enhancedText }}
        </pre>

        <p
          *ngIf="!resume.enhancedText && resume.status !== 'enhancing'"
          class="hint"
        >
          No enhanced version yet. Use <strong>“Enhance”</strong> on the card to generate one.
        </p>
      </div>
    </div>
  </section>

  <footer class="resume-dialog__footer">
    <button type="button" class="text-button" (click)="openFile()" [disabled]="!resume.fileUrl">
      <i class="fa fa-file"></i>
      <span>Open file</span>
    </button>
    <button type="button" class="text-button" (click)="useInChat()">
      <i class="fa fa-paper-plane"></i>
      <span>Send summary to chat</span>
    </button>
    <button type="button" class="primary-btn" (click)="close()">
      Close
    </button>
  </footer>
</div>
